import { Controller } from "@hotwired/stimulus"

// Контроллер для управления отображением выбора отделов в форме объявления
export default class extends Controller {
  static targets = ["allDepartments", "specificDepartments", "departmentsSelection"]

  connect() {
    this.toggleDepartments()
    if (this.hasAllDepartmentsTarget) {
      this.allDepartmentsTarget.addEventListener('change', this.toggleDepartments.bind(this))
    }
    if (this.hasSpecificDepartmentsTarget) {
      this.specificDepartmentsTarget.addEventListener('change', this.toggleDepartments.bind(this))
    }
  }

  toggleDepartments() {
    if (this.hasSpecificDepartmentsTarget && this.specificDepartmentsTarget.checked) {
      this.departmentsSelectionTarget.style.display = 'block'
    } else {
      this.departmentsSelectionTarget.style.display = 'none'
      // Снимаем все чекбоксы отделов если выбрано "Для всех"
      const checkboxes = this.departmentsSelectionTarget.querySelectorAll('input[type="checkbox"]')
      checkboxes.forEach(cb => cb.checked = false)
    }
  }
}
